(function ($) {
	  Drupal.behaviors.handlersForChangeInSize = {
	    attach: function (context) {
	    	// call jRespond and add breakpoints
	    	
	    	var jRes = jRespond([
	    		{
	    			label: 'Handheld',
	    			enter: 0,
	    			exit: 767
	    		},{
	    			label: 'Tablet',
	    			enter: 768,
	    			exit: 1199
	    		},{
	    			label: 'Desktop',
	    			enter: 1200,
	    			exit: 10000
	    		}
	    	]);

	    	//register enter and exit functions for multiple breakpoints and functions
	    	jRes.addFunc([
	    		{
	    			breakpoint: 'Handheld',
	    			enter: function() {
	    				myInitFuncHandheld();
	    			},
	    			exit: function() {
	    				myUnInitFuncHandheld();
	    			}
	    		},{
	    			breakpoint: 'Tablet',
	    			enter: function() {
	    				myInitFuncTablet();
	    			},
	    			exit: function() {
	    				myUnInitFuncTablet();
	    			}
	    		},{
	    			breakpoint: 'Desktop',
	    			enter: function() {
	    				myInitFuncDesktop();
	    			},
	    			exit: function() {
	    				myUnInitFuncDesktop();
	    			}
	    		}
	    	]);
	    	

        /*
		  mediaCheck({
			    media: '(max-width: 767px)',
			    entry: myInitFuncHandheld,
			    exit: exitMode
		  });
		  mediaCheck({
			    media: '(min-width: 768px)',
			    entry: myInitFuncTablet,
			    exit: exitMode
		  });	 		  
		  mediaCheck({
			    media: '(min-width: 1200px)',
			    entry: myInitFuncDesktop,
			    exit: exitMode
		  });    
        	    	
	    	
    		  function exitMode(mq) {
    			  //We check manually the modes
    			  var windowWidth = $(document).width();
    			  Drupal.behaviors.functions.consolog("Check Exit Mode windowWidth" + windowWidth);
		    	    if (windowWidth <= 767) {
		    	    		myInitFuncHandheld();
		    	    }
		    	    else if(windowWidth >= 768 && windowWidth < 1200){
		    	    		myInitFuncTablet();
		    	    }else{
		    	    		myInitFuncDesktop();
		    	    }
    		  }
    		  */
	    	
	    	
		    	function myInitFuncHandheld() {
		    	    Drupal.behaviors.functions.consolog("Handheld Mode Start ------------------------------------------>");
		    	    Drupal.behaviors.globalVariables.currentMediaType = "Handheld";
		    	    Drupal.behaviors.changeHeaderToHandheldMode();
		    	    Drupal.behaviors.changeFooterToHandheldMode();
		    	    genericFunctionsForAllSizes();
		    	}
		    	function myInitFuncTablet() {
		    	    Drupal.behaviors.functions.consolog("Tablet Mode Start ------------------------------------------>");
		    	    Drupal.behaviors.globalVariables.currentMediaType = "Tablet";
		    	    Drupal.behaviors.changeHeaderToTabletMode(false);
		    	    Drupal.behaviors.changeFooterToTabletMode();
		    	    genericFunctionsForAllSizes();
		    	}
		    	function myInitFuncDesktop() {
		    	    Drupal.behaviors.functions.consolog("Desktop Mode Start ------------------------------------------>");
		    	    Drupal.behaviors.globalVariables.currentMediaType = "Desktop";
		    	    Drupal.behaviors.changeHeaderToDesktopMode(false);
		    	    Drupal.behaviors.changeFooterToDesktopMode();
		    	    genericFunctionsForAllSizes();

		    	}	    	
		    	//MyUnInitFunctions
		    	function myUnInitFuncHandheld() {
		    	    Drupal.behaviors.functions.consolog("Un Handheld");
		    	}
		    	function myUnInitFuncTablet() {
		    	    Drupal.behaviors.functions.consolog("Un Tablet");
		    	}
		    	function myUnInitFuncDesktop() {
		    	    Drupal.behaviors.functions.consolog("Un Desktop");
		    	}
		    	
		    	function genericFunctionsForAllSizes() {
		    		Drupal.behaviors.footerNavigationScrollCreator($(window));
		    	    Drupal.behaviors.teaserImageMarginCalcLoaderAll();
		    	    Drupal.behaviors.changeHomeTeaserMode();
		    	    Drupal.behaviors.changeHomeTeaserStageBuildingMode();
		    	    Drupal.behaviors.changeHomeTeaserArtistResidencyMode();
		    	    Drupal.behaviors.changeHomeTeaserVirtualMuseumMode();
		    	}
	    }
	  }
	  
	  Drupal.behaviors.isPortraitMode = function () {
			if(window.innerHeight > window.innerWidth){
				return true;
			}else{
				return false;
			}
	  }
	    
	  
	  
	  
	})(jQuery);